import styled from 'styled-components'
import { StyledCardProps } from './interfaces'
import variants from './variants'

export const Card = styled.div<StyledCardProps>`
  width: fit-content;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  padding: ${({ theme }) => theme.padding.km6};
  border-color: ${({ $borderColor, theme }) => theme.color.border[$borderColor].default};

  ${({ $variant }) => variants[$variant]}
`
